export default {
  "path": "/demo/ModalFormDemo",
  "meta": {
    "name": "demo-表单弹出框",
    "title": "表单弹出框",
    "isComponentDoc": true,
    "category": "Data"
  }
};